import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { RicFormSchema } from './ricFormTypes';
import { renderElement } from './SchemaComponents/SchemaFormElementRenderer';

export function SchemaBasedRICForm({
  responseData,
  fetchResponseWithUpdatedData,
  schema,
}: {
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  schema?: RicFormSchema;
}) {
  const renderElements = () => {
    if (schema) {
      const { elements, metadata } = schema;

      return elements.map((formElement) =>
        renderElement({
          formElement,
          responseData,
          fetchResponseWithUpdatedData,
          ricMetadata: metadata,
        }),
      );
    }
    return null;
  };

  return <div className="form-container">{renderElements()}</div>;
}

export default SchemaBasedRICForm;
